import React from 'react'

const LandfillMessage = () => (
  <p className="p-3">Landfill at nearest available facility</p>
)

export default React.memo(LandfillMessage)
